import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import { Form, Field } from 'react-final-form';

import { getBusinessId } from 'constants/localStorageManager';
import statesList from 'constants/AmericanStates';
import BusinessApi from 'apis/Business';
import Toaster from 'components/Toaster';
import FormField, { FormError } from 'components/Form/FormField';
import { required } from 'utils/formValidators';
import 'assets/scss/soonoGetStarted.css';

class BillingAddress extends Component {
  updatePlan = values => {
    const { setBillingAddress, handleNext } = this.props;
    setBillingAddress(values);
    handleNext(values);
  };

  render() {
    const { onCancel, cardDetails } = this.props;
    const { zip } = cardDetails;

    return (
      <Form
        onSubmit={this.updatePlan}
        initialValues={{
          country: 'USA',
          zip,
        }}
        render={({ handleSubmit, form, submitting }) => (
          <form className="form mt-4 mb-5 text-left text-dark soono-transaction-form px-4">
            <FormField
              label="Street Address 1"
              name="addressLine1"
              containerClassName="form-group"
              inputClassName="form-control py-3 pl-4 pr-4"
              validate={required}
            />
            <FormField
              label="Street Address 2"
              name="addressLine2"
              containerClassName="form-group"
              inputClassName="form-control py-3 pl-4 pr-4"
            />
            <div className="row">
              <FormField
                label="City"
                name="city"
                containerClassName="form-group col-md-7"
                inputClassName="form-control py-3 pl-4 pr-4"
                validate={required}
              />
              <Field
                name="state"
                validate={required}
                render={({ input }) => (
                  <div className="form-group col-md-5 state-select">
                    <label htmlFor={input.name}>State</label>
                    <Select
                      id={input.name}
                      className="section"
                      options={statesList}
                      removeSelected
                      clearable={false}
                      {...input}
                    />
                    <FormError name={input.name} />
                  </div>
                )}
              />
            </div>
            <div className="row  mb-2">
              <FormField
                label="Zip Code"
                name="zip"
                containerClassName="form-group col"
                inputClassName="form-control py-3 pl-4 pr-4"
                validate={required}
              />
              <FormField
                label="Country"
                name="country"
                containerClassName="form-group col"
                inputClassName="form-control py-3 pl-4 pr-4"
                validate={required}
                disabled
              />
            </div>
            <div className="form-group mt-4">
              <button
                className="btn-warning btn-lg col-md-12 py-3 pl-5 pr-5 text-white text-bold border-0"
                type="submit"
                onClick={handleSubmit}
              >
                Review payment
              </button>
              <button
                type="button"
                onClick={onCancel}
                disabled={submitting}
                className="w-100 border-0 bg-transparent text-center mt-4"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      />
    );
  }
}

export default withRouter(BillingAddress);



// WEBPACK FOOTER //
// ./src/components/Form/payment/billingAddress.js